import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import AuthService from '../../service/Auth'
import service from '../../service/Mgt-station'
import TableListAllStation from './TableListAllStation'
import actions from "../../redux/actions";
import Swal from "sweetalert2";

const Container = styled.div`
`;



export default function Index(props) {

    const [permission, setPermission] = useState('')
    const [data, setData] = useState([])
    
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.master.setPath("/mgt-station"))
        const init = async () => {
            let permission = await AuthService.permission('mgt-station')
            setPermission(permission)
            let data = await service.search()
            if(data){
                setData(data)
            }
        }
        init()
    }, [dispatch])
    
    return(
        <Container  className={"section-mgt-station-all" + (props.className ? props.className : "")}>
            <div className="page-title">
                <img src='/image/railway-station.png' alt="icon-railway-station"/>
                <span>จัดการสถานี</span>
            </div>
            <div className="table-container">
                <TableListAllStation 
                    data={data} 
                    fncSetData={setData} 
                    permission={permission}
                />
            </div>
        </Container>
    )
}